import script from "./userManage.vue?vue&type=script&setup=true&lang=js"
export * from "./userManage.vue?vue&type=script&setup=true&lang=js"

import "./userManage.vue?vue&type=style&index=0&id=722960ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-722960ea"]])

export default __exports__